export enum ProteinDailyValueCalculationMethod {
  Default = 0,
  PDCAAS = 1
}